import { FC, FormEvent, useState } from 'react'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'

import { AuthFooter } from './AuthLayout'
import { PrimaryButton, SecondaryButton } from 'ui'
import { Input } from 'ui'

import useAuth from '../hooks/useAuth'

const AuthCodeScreen: FC<{
  email: string
  password?: string
}> = () => {
  const { t } = useTranslation('auth')
  const [code, setCode] = useState('')

  const { 
    isLoading,
    confirmAccount,
    resendConfirmationCode,
    resentConfirmationCode,
    errorMessage
  } = useAuth()

  return (
    <>
      {/* @TODO clean up translations... */}
      <h1 className="text-center hd-lg">{t('verification-code-title')}</h1>

      <p className="mt-16 text-center text-14">
        {t('verification-code-description')}
      </p>

      <form
        className="mt-40 space-y-16"
        onSubmit={(e: FormEvent<HTMLFormElement>) => {
          e.preventDefault()

          confirmAccount({ code })
        }}
      >
        <Input
          className="mt-16"
          value={code}
          onChange={(e) => setCode(e.currentTarget.value)}
          label={t('verification-code')}
          id="one-time-code"
          required
          placeholder={t('verification-code')}
          error={!!errorMessage.confirmAccount}
          helperText={
            errorMessage.confirmAccount ===
            'User cannot be confirmed. Current status is CONFIRMED' ? (
              <>
                User already confirmed,{' '}
                <Link href="/sign-in">
                  <a className="font-bold text-teal-3 underline">
                    try signing in
                  </a>
                </Link>{' '}
              </>
            ) : (
              errorMessage.confirmAccount
            )
          }
          autoComplete="one-time-code"
        />

        <AuthFooter>
          <div className="flex justify-between gap-24">
            <div>
              <SecondaryButton
                loading={isLoading}
                className="mx-auto block w-full max-w-420 md:mr-0 md:w-auto"
                onClick={() => {
                  resendConfirmationCode();
                }}
              >
                Resend code
              </SecondaryButton>
            </div>
            <div>
              <PrimaryButton
                loading={isLoading}
                disabled={!code}
                type="submit"
                className="mx-auto block w-full max-w-420 md:mr-0 md:w-auto"
              >
                {t('submit')}
              </PrimaryButton>
            </div>
          </div>
        </AuthFooter>
      </form>
      <footer className="mt-24 text-center">
        {resentConfirmationCode ? (
          <p className="inline-flex items-center justify-center py-px text-success-1 util-label">
            {t('code-sent')}
          </p>
        ) : null}
      </footer>
    </>
  )
}

export default AuthCodeScreen
